import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
    return (
        <footer className="z-20 bg-gray-900 border-t border-gray-800">
            {/* Subtle top accent line */}
            <div
                className="w-full h-px bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 opacity-60"
                aria-hidden="true"
            />

            <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4">
                <div className="flex flex-wrap items-center justify-center text-xs sm:text-sm text-gray-300">
                    <div className="flex items-center">
                        <Link
                            to="/linkedin"
                            className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-800 text-gray-100 hover:bg-purple-600 hover:text-white transition duration-150 ease-in-out focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-gray-900"
                            aria-label="LinkedIn"
                        >
                            <svg
                                className="w-4 h-4 fill-current"
                                viewBox="0 0 32 32"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M23.3 8H8.7c-.4 0-.7.3-.7.7v14.7c0 .3.3.6.7.6h14.7c.4 0 .7-.3.7-.7V8.7c-.1-.4-.4-.7-.8-.7zM12.7 21.6h-2.3V14h2.4v7.6h-.1zM11.6 13c-.8 0-1.4-.7-1.4-1.4 0-.8.6-1.4 1.4-1.4.8 0 1.4.6 1.4 1.4-.1.7-.7 1.4-1.4 1.4zm10 8.6h-2.4v-3.7c0-.9 0-2-1.2-2s-1.4 1-1.4 2v3.8h-2.4V14h2.3v1c.3-.6 1.1-1.2 2.2-1.2 2.4 0 2.8 1.6 2.8 3.6v4.2h.1z" />
                            </svg>
                        </Link>
                    </div>

                    <span className="mx-3 text-gray-600 hidden xs:inline-block sm:inline-block">•</span>

                    <div className="flex items-center">
                        <span className="font-semibold text-gray-100 mr-1">Phone:</span>
                        <a
                            href="tel:+441172510424"
                            className="hover:text-purple-300 transition-colors duration-150"
                        >
                            +44 1172 510424
                        </a>
                    </div>

                    <span className="mx-3 text-gray-600 hidden xs:inline-block sm:inline-block">•</span>

                    <div className="flex items-center">
                        <span className="font-semibold text-gray-100 mr-1">Email:</span>
                        <a
                            href="mailto:info@agmtechnologies.co.uk"
                            className="hover:text-purple-300 transition-colors duration-150"
                        >
                            info@agmtechnologies.co.uk
                        </a>
                    </div>

                    <span className="mx-3 text-gray-600 hidden xs:inline-block sm:inline-block">•</span>

                    <div className="flex items-center text-gray-400">
                        <span>&copy; 2026 AGM Technologies. All rights reserved.</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
